import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useAppMeta, useAuth } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { EditOutlined } from "@mui/icons-material";
import { BranchDetailContext } from "contexts/BranchDetailContext";
import BranchBasicDetails from "./branchComponents/BranchBasicDetails";
import { useGetBranchDetailQuery } from "store/services/branchApi";
import BranchDetailTabs from "./branchComponents/BranchDetailTabs";

const BranchDetailScreen = () => {
  const { isAdmin } = useAuth();
  const { id } = useParams();
  const breadcrumbs = [
    { title: "Branches", path: "/app/crm/branch/list" },
    { title: "Branch Detail" },
  ];

  const {
    data: branchDetail,
    isLoading: loadingDetail,
    error,
  } = useGetBranchDetailQuery(id);

  const PageActions = () => (
    <Link to={`/app/crm/branch/${id}/edit`} state={{ from: "detail" }}>
      {isAdmin && (
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      )}
    </Link>
  );

  useAppMeta("District Detail");

  return (
    <BranchDetailContext.Provider value={{ branchDetail, loadingDetail }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingDetail}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <BranchBasicDetails />
          <Divider />

          <BranchDetailTabs />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </BranchDetailContext.Provider>
  );
};

export default BranchDetailScreen;
